import { Box, Typography, makeStyles } from "@material-ui/core";
import * as React from "react";

import { textStyles } from "@/designTokens";
import theme from "@/theme";
import { MATCH_SCORE_COLOR } from "@/utilities/compatibilityColors";

import BronzeCrown from "@assets/image/compatibility_rank_bronze.svg";
import GoldCrown from "@assets/image/compatibility_rank_gold.svg";
import SilverCrown from "@assets/image/compatibility_rank_silver.svg";

const useStyles = makeStyles(() => ({
  root: { display: "flex", alignItems: "center", gap: 4, flexShrink: 0, whiteSpace: "nowrap" },
  valueRow: { display: "flex", alignItems: "flex-end", gap: 4 },
  value: { ...textStyles["Number/M"], color: MATCH_SCORE_COLOR },
  valueLarge: { ...textStyles["Number/L"] },
  valueExtraLarge: { ...textStyles["Number/XL"] },
  valueDefault: { color: theme.palette.semantic["text/primary"] },
  unit: { ...textStyles["Number/Caption"], color: theme.palette.semantic["text/secondary"] },
}));

/**
 * 王冠は一覧（相性プランナー一覧＝診断結果・ホーム、または検索一覧）の順位の上位3人だけ。
 * 相性スコアの閾値や画面の種類で王冠を出す仕組みは持たない（詳細に出すときは一覧から順位を引き継ぐ）。
 */
export const CompatibilityScoreDisplay: React.FC<{
  score: number;
  rank?: number;
  showUnit?: boolean;
  showCrown?: boolean;
  crownSize?: number;
  size?: "M" | "L" | "XL";
  tone?: "accent" | "default";
}> = ({ score, rank, showUnit = true, showCrown = true, crownSize, size = "M", tone = "accent" }) => {
  const classes = useStyles();
  const crown = rank === 1 ? GoldCrown : rank === 2 ? SilverCrown : rank === 3 ? BronzeCrown : undefined;
  return (
    <Box className={classes.root} data-testid="compatibility-score" data-rank={rank}>
      {showCrown && crown && (
        <img
          src={crown}
          alt={`相性順位${rank}位`}
          style={crownSize ? { width: crownSize, height: crownSize } : undefined}
        />
      )}
      <Box className={classes.valueRow}>
        <Typography component="span" className={`${classes.value} ${size === "XL" ? classes.valueExtraLarge : size === "L" ? classes.valueLarge : ""} ${tone === "default" ? classes.valueDefault : ""}`}>
          {score.toFixed(1)}
        </Typography>
        {showUnit && (
          <Typography component="span" className={classes.unit}>
            / 5.0
          </Typography>
        )}
      </Box>
    </Box>
  );
};
